import { useEffect, useState } from "react";
import { Box, Typography, } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchEntityById } from "../../../apis/apiService";
import { useParams } from "react-router-dom";
import { extractTextFromHTML } from "../../../utils/textUtils";

const MilestoneActivityStream = () => {
  const [showData, setShowData] = useState([]);
  const { id } = useParams();

  const activityStatus = async () => {
    try {
      const response = await fetchEntityById("milestones/activity", id);
      //console.log()("Activity responsemm:", response.data);
      setShowData((prev) =>
        Array.isArray(response.data) ? response.data : []
      );
    } 
    catch (error) {
      console.error("Error fetching activity data:", error);
      setShowData([]);
    }
  };
  useEffect(() => {
    activityStatus();
  }, [id]);

  useEffect(() => {
    //console.log()("Updated showData:", showData);
  }, [showData]);
  const borderColors = ["#2196f3", "#4caf50", "#ff9800"]; // Blue, Green, Orange
  return (
    <Box className="border  rounded my-3 py-3 showActivities ">
      {showData.map((activity, index) => {
        const [date, time] = activity.added_at.split(" ");
        return (
          <Box key={index} className="row" mb={3}>
            <Box className="col-md-3" textAlign="right">
              <Typography variant="body2" fontWeight="bold">
                {date}
              </Typography>
              <Typography variant="body2" className="text-rgba-gray">
                {time}
              </Typography>
            </Box>
            
            <Box
              className="col-md-9"
              sx={{
                borderLeft: `4px solid ${
                  borderColors[index % borderColors.length]
                }`,
                paddingLeft: 2,
              }}
            >
              {/* <Typography variant="body2" className="text-rgba-gray">
                {activity.added_by}
              </Typography> */}

              {activity.comments && (
                <Box ml={2}>
                  {activity.comments.split(",").map((comment, idx) => (
                    <Typography key={idx} variant="body2" fontWeight="bold">
                      {extractTextFromHTML(comment.trim())}{" "}
                      {/* Trim removes any extra spaces */}
                    </Typography>
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default MilestoneActivityStream;
